module.exports = () => {
  return {
    subscription: [],
    availableSubscriptions: [],
    subscriptions: [],
  }
}